import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex, Text, TextVariant } from '@mprolab/uikit'

const Wrapper = styled(Flex)<{ borderColor: string; backgroundColor: string }>`
  width: max-content;
  height: max-content;
  padding: 4px 12px;
  border-radius: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ borderColor }) => borderColor};
  background-color: ${({ backgroundColor }) => backgroundColor};
`

interface PercentageCellProps {
  percentage: number
}

const PercentageCell: React.FC<PercentageCellProps> = ({ percentage }) => {
  const { colors } = useTheme()
  const getColor = (percentage: number) => {
    switch (true) {
      case percentage < 2:
        return { borderColor: colors.magenta, backgroundColor: 'rgba(255, 2, 154, 0.30)' }
      case percentage < 8:
        return { borderColor: colors.purple, backgroundColor: 'rgba(146, 57, 255, 0.30)' }
      default:
        return { borderColor: colors.cyan, backgroundColor: 'rgba(3, 245, 255, 0.3)' }
    }
  }

  const cellColor = getColor(percentage)

  return (
    <Wrapper {...cellColor}>
      <Text variant={TextVariant.BODY_SMALL}>{`${percentage}%`}</Text>
    </Wrapper>
  )
}

export default PercentageCell
